import type { GamePollVM } from '@tv-casino/viewmodels/components/gamePollModel.js';
import styles from './GamePollBoard.module.css';

/**
 * The vote as the room reads it off the TV: one bar per game, filling with the
 * ballots behind it, and the names underneath so everyone can see who still
 * owes a pick. Watch-only — the ballots come off the phones.
 */
export function GamePollBoard({ vm }: { vm: GamePollVM }) {
  return (
    <section className={styles.board} aria-label="Game poll">
      <p className={styles.heading}>Table vote</p>
      <p className={styles.title}>{vm.title}</p>
      <p className={styles.meta}>
        {vm.empty ? 'Pick a game on your phone' : `${vm.countLine} · ${vm.leaderLine}`}
      </p>

      <div className={styles.rows}>
        {vm.rows.map((row) => (
          <div
            key={row.game}
            className={[styles.row, row.leading ? styles.leading : ''].filter(Boolean).join(' ')}
          >
            <span className={styles.bar} style={{ width: `${row.percent}%` }} aria-hidden="true" />
            <span className={styles.label}>{row.label}</span>
            <span className={styles.voters}>{row.voters.join(', ')}</span>
            <span className={styles.count}>{row.votes}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
